import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.237 18.49a.315.315 0 01-.221.221l-2.877.77a.314.314 0 01-.3-.08l-2.107-2.107a.312.312 0 01-.08-.3l.798-2.98a.315.315 0 01.22-.22l2.877-.772a.314.314 0 01.301.081l2.106 2.107a.31.31 0 01.08.3l-.797 2.98zm-.006-6.77a2.266 2.266 0 00-2.19-.586l-2.875.77c-.017.005-.033.016-.05.022L4.688 2.5 3.306 3.882l1.4 1.399L2 7.986l1.382 1.382 1.845-1.846L6.564 8.86l-1.768 1.83 1.383 1.383 2.627-2.69 3.864 3.865c-.036.087-.084.168-.108.26l-.799 2.98c-.208.78.016 1.619.587 2.19l2.105 2.105a2.277 2.277 0 002.19.587l2.877-.77a2.274 2.274 0 001.603-1.603l.798-2.98a2.274 2.274 0 00-.587-2.19L19.23 11.72z"
    />
  </svg>
);
